import { render, staticRenderFns } from "./lamsRegLegalTraining.vue?vue&type=template&id=2533e626&scoped=true&"
import script from "./lamsRegLegalTraining.vue?vue&type=script&lang=js&"
export * from "./lamsRegLegalTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2533e626",
  null
  
)

export default component.exports